export const subRModuleMap: Record<string, string> = {
  'operations.top-sales-performers': 'top-sales-performers-report',
  'inventory.stock-take-reconciliation': 'stock-takes-report',
  'inventory.stock-receipt': 'stock-receipt-report',
  'inventory.stock-issues': 'stock-issues-report',
  'inventory.purchase-value': 'purchase-value-report',
  'inventory.total-batch-production-value': 'total-batch-production-value-report'
};
export const getSubRModuleName = (dashboard: string, widget: string | undefined): string => {
  const widgetKey = `${dashboard}.${widget}`;
  return subRModuleMap[widgetKey] || `${widget}-report`;
};

/**
 * Calculate the total value from an array of data objects
 * @param data - Array of data objects
 * @param totalKey - The key to sum up
 * @param precision - Number of decimal places (default: 2)
 * @returns The total as a string with fixed precision
 */
export const calculateTotalTableData = (
  data: any[],
  totalKey: string,
  precision: number = 2
): string => {
  if (data.length === 0) {
    return '0';
  }
  return data.reduce((acc, curr) => acc + curr[totalKey], 0).toFixed(precision);
};

/**
 * Format a parameter name by removing underscores and capitalizing words
 * @param paramName - The parameter name to format (e.g., 'staff_id')
 * @returns Formatted string with spaces and capitalized words (e.g., 'Staff Id')
 */
export const formatUniqueIdName = (paramName: string): string => {
  return paramName.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};
